const PLACE_TYPE_PLANTER = 1;
const PLACE_TYPE_FIELD = 2;

// HACK: 肥料IDは固定値で保持しているため、管理画面側で登録した肥料IDと合わせる必要あり
const FERTILIZER_YUKIDOUBLE = 1;
const FERTILIZER_WIDEBASIC = 2;
const FERTILIZER_VEGEADVANCE = 3;
const FERTILIZER_TOMATOOSUSUME = 6;
const FERTILIZER_TAMANEGIOSUSUME = 7;
const FERTILIZER_ICHIGOOSUSUME = 8;

// パラメータと商品IDの辞書
const FERTILIZER_CONVERT = {
    "widebasic":       FERTILIZER_WIDEBASIC,
    "vegeadvance":     FERTILIZER_VEGEADVANCE,
    "yukidouble":      FERTILIZER_YUKIDOUBLE,
    "tomatoosusume":   FERTILIZER_TOMATOOSUSUME,
    "ichigoosusume":   FERTILIZER_ICHIGOOSUSUME,
    "tamanegiosusume": FERTILIZER_TAMANEGIOSUSUME,
};

// おすすめの野菜グループ
const RC_TOMATOOSUSUME_LIST = ['トマト','ミニトマト'];
const RC_ICHIGOOSUSUME_LIST = ['イチゴ'];
const RC_TAMANEGIOSUSUME_LIST = ['タマネギ','葉ネギ','白ネギ（溝施肥）','白ネギ（全面施肥）'];

// 白ネギ
const SHIRONEGI_LIST = ['白ネギ（溝施肥）','白ネギ（全面施肥）'];

var fertilizer = '';

// 野菜名称とカテゴリの組み合わせを保持する連想配列
var vc_dict = {}

$(function() {
    $doc = $(document);

    $doc.on('click', '.prtc-show-growing-season-modal img', showGrowingSeasonModal);
    $doc.on('click', '#prtcSimulatorSubmitBtn', onClickSimulatorSubmitBtn);

    $doc.on('change', '#prtcFertilizerSelector', onChangeFertilizerSelector);
    $doc.on('change', '#prtcCategorySelector', onChangeCategorySelector);
    $doc.on('change', '#prtcVegetableSelector', onChangeVegetableSelector);
    $doc.on('change', '[name="place_type"]', onChangePlaceType);
    $doc.on('change', '.prtc-simulator-validation-target', changeSimulatorSubmitBtnStatus);
    $doc.on('blur', '.prtc-simulator-validation-target', changeSimulatorSubmitBtnStatus);

    $doc.on('blur', '.prtc-input-planter-size, .prtc-input-field-size', onChangeInputSize);

    $doc.on('change', '.prtc-input-planter-size', changeInputPlanterSizeStatus);
    $doc.on('blur', '.prtc-input-planter-size', changeInputPlanterSizeStatus);

    initPrtcSimulator();
})

/**
 * 施肥量シミュレータページ初期化
 */
function initPrtcSimulator() {
    createVegeCategoryDict();

    fertilizer = getQueryParam('fertilizer');
    var vegetable_name = getQueryParam('vegetable');

    setFertilizerSelectorOptionElem()
        .then(function() {
            // 肥料のオプションが追加された後の処理
            return setVegetableCategorySelectorOptionElem();
        })
        .then(function() {
            // 野菜カテゴリーのオプションが追加された後の処理

            if (fertilizer) {
                // 肥料の選択
                var fertilizerId = null;
                if (fertilizer) {
                    fertilizerId = FERTILIZER_CONVERT[fertilizer];
                    $('#prtcFertilizerSelector').val(fertilizerId);
                    $('#prtcFertilizerSelector').addClass('changed');
                    onChangeFertilizerSelector();
                }

                // 野菜の選択
                setVegetableSelectorOptionElem();

            } else if (vegetable_name) {
                // カテゴリの選択
                var categoryId = null;
                if (vegetable_name in vc_dict) {
                    categoryId = vc_dict[vegetable_name].categoryId;
                    $('#prtcCategorySelector').val(categoryId);
                    $('#prtcCategorySelector').addClass('changed');
                }

                // 野菜の選択
                setVegetableSelectorOptionElem();
            }
        })
        .catch(function(error) {
            // エラーハンドリング
            console.error(error);
        });

    onChangePlaceType();
}

/**
 * 栽培場所選択ラジオ変更時処理
 * @param e
 */
function onChangePlaceType(e) {
    const placeType = $('[name="place_type"]:checked').val();
    const vegetable_name = $('#prtcVegetableSelector :selected').text();

    if (placeType == PLACE_TYPE_PLANTER) {
        if (vegetable_name && SHIRONEGI_LIST.includes(vegetable_name) ) {
            // プランター
            $('.prtc-field-block').hide();
            $('#prtcFieldVertical').val('');
            $('#prtcFieldHorizontal').val('');
            // 露地栽培
            $('.prtc-planter-block').hide();
            $('#prtcRoundDiameter').val('');
            $('#prtcPlanterSquareVertical').val('');
            $('#prtcPlanterSquareHorizontal').val('');

            // メッセージブロック
            $('#place-msg-box').find('p').text('白ネギの栽培は土寄せを行う必要があるので、プランターや鉢よりも畑での栽培をおすすめします。');
            $('#place-msg-box').show();
        } else {
            // プランター
            $('.prtc-field-block').hide();
            $('.prtc-planter-block').show();
            $('.prtc-show-after-radio-checking').show();
            // 露地栽培用の入力欄をリセット
            $('#prtcFieldVertical').val('');
            $('#prtcFieldHorizontal').val('');

            // メッセージブロック
            $('#place-msg-box').hide();
        }
    } else if (placeType == PLACE_TYPE_FIELD) {
        // 露地栽培
        $('.prtc-field-block').show();
        $('.prtc-planter-block').hide();
        $('.prtc-show-after-radio-checking').show();
        // プランター用の入力欄をリセット
        $('#prtcRoundDiameter').val('');
        $('#prtcPlanterSquareVertical').val('');
        $('#prtcPlanterSquareHorizontal').val('');

        // メッセージブロック
        $('#place-msg-box').hide();
    } else {
        $('.prtc-field-block').hide();
        $('.prtc-planter-block').hide();
        $('.prtc-show-after-radio-checking').hide();

        // メッセージブロック
        $('#place-msg-box').hide();
    }
}

/**
 * シミュレーション実行ボタンクリック時処理
 */
function onClickSimulatorSubmitBtn(e) {
    e.preventDefault();

    const placeType = $('[name="place_type"]:checked').val();
    const forPlanter = (placeType == PLACE_TYPE_PLANTER);
    const verticalVal = forPlanter? $('#prtcPlanterSquareVertical').val(): $('#prtcFieldVertical').val();
    const horizontalVal = forPlanter? $('#prtcPlanterSquareHorizontal').val(): $('#prtcFieldHorizontal').val();

    // シミュレーション結果を取得
    const url = PRTC_API_URL_BASE + 'simulation';
    const params = {
        fertilizer_no: $('[name="fertilizer_no"] :selected').val(),
        vegetable_no: $('[name="vegetable_no"] :selected').val(),
        place_type: placeType,
        diameter: $('#prtcRoundDiameter').val(),
        vertical: verticalVal,
        horizontal: horizontalVal,
    };

    // 栽培記事リンクのタイトルを更新
    const vegetable_name = $('#prtcVegetableSelector :selected').text();
    $('.prtc-blogs-link').find('h4').text(vegetable_name + 'の栽培方法はこちら');

    $.get(url, params)
        .done(function(data) {
            if (typeof data.msg !== 'undefined' && data.msg !== '') {
                // バリデーション失敗
                alert(data.msg);
            } else {
                // バリデーション成功
                setSimulatorResultArea(placeType, data);

                // 値を挿入し終わったらシミュレーション結果エリアを表示
                $('.prtc-simulator-result-area').show();
            }
        })
        .fail(function(error) {
            console.log(error);
        });
}

/**
 * 栽培時期カレンダー用モーダルを表示
 */
function showGrowingSeasonModal() {
    const $container = $(this).parent();

    const src = $container.find('.prtc-growing-season').attr('src');

    // モーダル内のimgタグに画像をセット
    const $modal = $('#prtcGrowingSeasonModal');
    $modal.find('.prtc-growing-season').attr('src', src);

    // モーダルを表示
    $modal.fadeIn();
}

/**
 * フォームの入力状況に応じてシミュレーション実行ボタンの活性・非活性を切り替え
 */
function changeSimulatorSubmitBtnStatus() {
    $('#prtcSimulatorSubmitBtn').prop('disabled', hasBlankFormParts());
    $('.prtc-simulator-result-area').hide();
}

/**
 * 未入力・未選択のフォームパーツの有無を検証
 * @return {boolean}
 */
function hasBlankFormParts() {
    // 肥料
    if ($('#prtcFertilizerSelector').find(':selected').val() === '') {
        return true;
    }
    // カテゴリ
    if ($('#prtcCategorySelector').find(':selected').val() === '') {
        return true;
    }
    // 野菜
    if ($('#prtcVegetableSelector').find(':selected').val() === '') {
        return true;
    }
    // 栽培場所
    if (typeof $('[name="place_type"]:checked').val() === 'undefined') {
        return true;
    }
    // 栽培面積
    if ($('[name="place_type"]:checked').val() == PLACE_TYPE_PLANTER) {
        // プランターの場合
        const isBlankRoundDiameter = ($('#prtcRoundDiameter').val() === '');
        const isBlankPlanterSquareVertical = ($('#prtcPlanterSquareVertical').val() === '');
        const isBlankPlanterSquareHorizontal = ($('#prtcPlanterSquareHorizontal').val() === '');

        if (
            (isBlankRoundDiameter && (isBlankPlanterSquareVertical || isBlankPlanterSquareHorizontal))
             || (!isBlankPlanterSquareVertical && isBlankPlanterSquareHorizontal)
             || (isBlankPlanterSquareVertical && !isBlankPlanterSquareHorizontal)
        ) {
            return true;
        }

    } else if ($('[name="place_type"]:checked').val() == PLACE_TYPE_FIELD) {
        // 露地栽培の場合
        const isBlankFieldVertical = ($('#prtcFieldVertical').val() === '');
        const isBlankFieldHorizontal = ($('#prtcFieldHorizontal').val() === '');

        if (
            (!isBlankFieldVertical && isBlankFieldHorizontal)
            || (isBlankFieldVertical && !isBlankFieldHorizontal)
            || (isBlankFieldVertical && isBlankFieldHorizontal)
        ) {
            return true;
        }
    }


    // 何も問題がなければfalse
    return false;
}

/**
 * プランターサイズ入力欄のステータスを切り替え
 */
function changeInputPlanterSizeStatus() {
    if ($(this).hasClass('round') && $(this).val() !== '') {
        $('.prtc-input-planter-size.round').prop('disabled', false);
        $('.prtc-input-planter-size.square').prop('disabled', true);
        $('.prtc-input-planter-size.square').val('');
    } else if ($(this).hasClass('square') && ($('#prtcPlanterSquareVertical').val() !== '' || $('#prtcPlanterSquareHorizontal').val() !== '')) {
        $('.prtc-input-planter-size.square').prop('disabled', false);
        $('.prtc-input-planter-size.round').prop('disabled', true);
        $('.prtc-input-planter-size.round').val('');
    } else {
        $('.prtc-input-planter-size.round').prop('disabled', false);
        $('.prtc-input-planter-size.square').prop('disabled', false);
    }
}


/**
 * 肥料セレクトボックスのoption要素をセット
 */
function setFertilizerSelectorOptionElem() {
    return new Promise(function(resolve, reject) {
        const url = PRTC_API_URL_BASE + 'fertilizer';
        $.get(url)
            .done(function(data) {
                let optionElemHtml = '<option value="">選択してください</option>';
                data.items.map(function(item, idx) {
                    optionElemHtml += `<option value="${item.no}">${item.name}</option>`;
                });
                $('#prtcFertilizerSelector').html(optionElemHtml);
                resolve();
            })
            .fail(function(error) {
                console.log(error);
                reject(error);
            });
    });
}

/**
 * 肥料選択時処理
 */
function onChangeFertilizerSelector(e) {
    const fertilizerId = parseInt($('#prtcFertilizerSelector :selected').val());

    // 商品に対応するカテゴリを設定
    if (fertilizerId === FERTILIZER_TOMATOOSUSUME ||
        fertilizerId === FERTILIZER_ICHIGOOSUSUME) {
        $('#prtcCategorySelector option').filter(function () {
            return $(this).text() === '果菜類';
        }).prop("selected", true);
        onChangeCategorySelector();
    } else if(fertilizerId === FERTILIZER_TAMANEGIOSUSUME) {
        $('#prtcCategorySelector option').filter(function () {
            return $(this).text() === '葉菜類';
        }).prop("selected", true);
        onChangeCategorySelector();
    }
    setVegetableSelectorOptionElem();
}

/**
 * 野菜カテゴリセレクトボックスのoption要素をセット
 */
function setVegetableCategorySelectorOptionElem() {
    return new Promise(function(resolve, reject) {
        const url = PRTC_API_URL_BASE + 'category';
        $.get(url)
            .done(function(data) {
                let optionElemHtml = '<option value="">選択してください</option>';
                data.items.map(function(item, idx) {
                    optionElemHtml += `<option value="${item.no}">${item.name}</option>`;
                });
                $('#prtcCategorySelector').html(optionElemHtml);
                resolve();
            })
            .fail(function(error) {
                console.log(error);
                reject(error);
            });
    });
}

/**
 * 野菜カテゴリ選択時処理
 * @param e
 */
function onChangeCategorySelector(e) {
    const categoryNo = $('#prtcCategorySelector :selected').val();
    const categoryName = $('#prtcCategorySelector :selected').text();
    // カテゴリが未指定の場合は、野菜セレクタを初期化して非活性化
    if (categoryNo === '') {
        let optionElemHtml = '<option value="">カテゴリを選択してください</option>';
        $('#prtcVegetableSelector').prop('disabled', true);
        $('#prtcVegetableSelector').html(optionElemHtml);
        return false;
    }
    $('#prtcCategorySelector').addClass('changed');

    // 野菜情報を取得
    setVegetableSelectorOptionElem();
}

/**
 * 野菜セレクトボックスのoption要素をセット
 */
function setVegetableSelectorOptionElem() {
    return new Promise(function(resolve, reject) {
        // GETパラメータの取得と、肥料の取得
        var vegetable_name = getQueryParam('vegetable');
        var categoryNo = $('#prtcCategorySelector :selected').val();
        var categoryName = $('#prtcCategorySelector :selected').text();
        var rcDict = {};    // おすすめ
        var otherDict = {}; // その他
        var rcVegetableList = []; // おすすめ野菜リスト

        if (!categoryNo && vegetable_name) {
            // URLパラメータに野菜が指定されている場合
            categoryNo = vc_dict[vegetable_name].categoryId
            categoryName = vc_dict[vegetable_name].name
        }

        const url = PRTC_API_URL_BASE + 'vegetable';
        const params = {
            category_no: categoryNo,
        };

        // 選択されている肥料から、オススメの野菜を決定
        var fertilizerId = parseInt($('#prtcFertilizerSelector :selected').val());
        if (fertilizerId === FERTILIZER_TOMATOOSUSUME) {
            rcVegetableList = RC_TOMATOOSUSUME_LIST;
        } else if (fertilizerId === FERTILIZER_ICHIGOOSUSUME) {
            rcVegetableList = RC_ICHIGOOSUSUME_LIST
        } else if (fertilizerId === FERTILIZER_TAMANEGIOSUSUME) {
            rcVegetableList = RC_TAMANEGIOSUSUME_LIST
        } else {
            rcVegetableList = []
        }

        $.get(url, params)
            .done(function(data) {
                let optionElemHtml = '<option value="">選択してください</option>';
                if (data.items && data.items.length > 0) {
                    if (rcVegetableList.length === 0) {
                        // 野菜のグルーピングが必要ない場合
                        data.items.map(function(item, idx) {
                            if (vegetable_name && item.name === vegetable_name) {
                                optionElemHtml += `<option value="${item.no}" selected>${item.name}</option>`;
                                $('#prtcVegetableSelector').addClass('changed');
                            } else {
                                optionElemHtml += `<option value="${item.no}">${item.name}</option>`;
                            }
                        });
                        if ($('#prtcCategorySelector :selected').val()) {
                            $('#prtcVegetableSelector').prop('disabled', false);
                        } else {
                            $('#prtcVegetableSelector').prop('disabled', true);
                        }
                    } else {
                        // 野菜のグルーピングが必要な場合
                        data.items.forEach(function(item) {
                            if (rcVegetableList.includes(item.name)) {
                                rcDict[item.no] = item.name;
                            } else {
                                otherDict[item.no] = item.name;
                            }
                        });
                        if (Object.keys(rcDict).length > 0) {
                            optionElemHtml += '<optgroup label="おすすめの野菜">';
                            $.each(rcDict, function(key, value) {
                                if (vegetable_name && value === vegetable_name) {
                                    optionElemHtml += `<option value="${key}" selected>${value}</option>`;
                                    $('#prtcVegetableSelector').addClass('changed');
                                } else {
                                    optionElemHtml += `<option value="${key}">${value}</option>`;
                                }
                            });
                            optionElemHtml += '</optgroup>';
                        }
                        if (Object.keys(otherDict).length > 0) {
                            optionElemHtml += '<optgroup label="その他の野菜">';
                            $.each(otherDict, function(key, value) {
                                if (vegetable_name && value === vegetable_name) {
                                    optionElemHtml += `<option value="${key}" selected>${value}</option>`;
                                    $('#prtcVegetableSelector').addClass('changed');
                                } else {
                                    optionElemHtml += `<option value="${key}">${value}</option>`;
                                }
                            });
                            optionElemHtml += '</optgroup>';
                        }
                    }
                    if ($('#prtcCategorySelector :selected').val()) {
                        $('#prtcVegetableSelector').prop('disabled', false);
                    } else {
                        $('#prtcVegetableSelector').prop('disabled', true);
                    }
                } else {
                    optionElemHtml = `<option value="">${categoryName}の野菜が見つかりませんでした</option>`;
                    $('#prtcVegetableSelector').prop('disabled', true);
                }

                $('#prtcVegetableSelector').html(optionElemHtml);
                resolve();
            })
            .fail(function(error) {
                console.log(error);
                reject(error);
            });
    });
}

/**
 * シミュレーション結果をセット
 * @param placeType 栽培場所種別
 * @param data シミュレーション結果
 */
function setSimulatorResultArea(placeType, data) {
    const $prtcSimulatorResultArea = $('.prtc-simulator-result-area');

    const standard = data.standard;
    const vegetable = data.vegetable;

    // 栽培場所に応じて表示内容の切り替え
    if (placeType == PLACE_TYPE_PLANTER) {
        $prtcSimulatorResultArea.find('.prtc-for-planter').show();
        $prtcSimulatorResultArea.find('.prtc-for-field').hide();
    } else {
        $prtcSimulatorResultArea.find('.prtc-for-planter').hide();
        $prtcSimulatorResultArea.find('.prtc-for-field').show();
    }

    // 画像
    $prtcSimulatorResultArea.find('.prtc-vegetable-image').attr('src', vegetable.image_vegetable).attr('alt', vegetable.name);
    // 野菜名称
    $prtcSimulatorResultArea.find('.prtc-vegetable-name').text(vegetable.name);

    // 表
    // 1列目 一回あたりの計量
    const firstFertilizerHtml = `${standard.first_fertilizer}<br>${standard.first_fertilizer_gram}`;
    const extraFertilizerHtml = `${standard.extra_fertilizer}<br>${standard.extra_fertilizer_gram}`;
    const secondaryMaterialHtml = `${standard.secondary_material}`;
    $prtcSimulatorResultArea.find('.row1.col1').html(firstFertilizerHtml); // 1行目
    $prtcSimulatorResultArea.find('.row2.col1').html(extraFertilizerHtml); // 2行目
    $prtcSimulatorResultArea.find('.row3.col1').html(secondaryMaterialHtml); // 3行目
    // 2列目 肥料を与える回数
    $prtcSimulatorResultArea.find('.row1.col2').text(standard.frequency_first_fertilizer); // 1行目
    $prtcSimulatorResultArea.find('.row2.col2').text(standard.frequency_extra_fertilizer); // 2行目
    $prtcSimulatorResultArea.find('.row3.col2').text(standard.frequency_secondary_material); // 3行目
    // 目安株数
    if (placeType == PLACE_TYPE_PLANTER && standard.number_of_plants) {
        $prtcSimulatorResultArea.find('.prtc-quantity').text(standard.number_of_plants);
        $prtcSimulatorResultArea.find('.prtc-quantity').parent().show();
    } else {
        $prtcSimulatorResultArea.find('.prtc-quantity').parent().hide();
    }

    // PC用カレンダー
    $prtcSimulatorResultArea.find('.prtc-growing-season-box .pc').find('.prtc-growing-season').attr('src', vegetable.image_horizontal).attr('alt', vegetable.image_horizontal_filename);
    // SP用カレンダー
    $prtcSimulatorResultArea.find('.prtc-growing-season-box .sp').find('.prtc-growing-season').attr('src', vegetable.image_vertical).attr('alt', vegetable.image_vertical_filename);

    // 栽培記事リンク
    if (vegetable.slug) {
        $prtcSimulatorResultArea.find('#blog-link').attr('href', '/blogs/method/' + vegetable.slug);
        $prtcSimulatorResultArea.find('.prtc-blogs-link').show();
    } else {
        $prtcSimulatorResultArea.find('.prtc-blogs-link').hide();
    }
}

/**
 * 栽培面積入力時の処理
 */
function onChangeInputSize() {
    const val = $(this).val();
    if (val === '') {
        return false;
    }

    let area = 0;
    // プランター栽培
    if ($(this).hasClass('prtc-input-planter-size')) {
        // 円形の場合
        if ($(this).hasClass('round')) {
            area = (val / 2) * (val / 2) * 3.14;
        } else {
            // 鉢の場合
            const planterVertical = $('.prtc-input-planter-size.vertical').val();
            const planterHorizontal = $('.prtc-input-planter-size.horizontal').val();
            // 縦横のどちらかが未入力なら処理終了
            if (!planterVertical || !planterHorizontal) {
                return false;
            }
            area = planterVertical * planterHorizontal;
        }
    } else {
        // 露地栽培
        const fieldVertical = $('.prtc-input-field-size.vertical').val();
        const fieldHorizontal = $('.prtc-input-field-size.horizontal').val();
        // 縦横のどちらかが未入力なら処理終了
        if (!fieldVertical || !fieldHorizontal) {
            return false;
        }
        area = fieldVertical * fieldHorizontal;
    }

    // 栽培場所によって許容する面積下限
    const areaLowerLimit = ($(this).hasClass('prtc-input-planter-size')? 200: 0.5);
    const areaTypeText = ($(this).hasClass('prtc-input-planter-size')? 'サイズ': '面積');
    // 面積が下限を下回る場合のみアラート
    if (area < areaLowerLimit) {
        alert(`もう少し大きい${areaTypeText}での栽培をおすすめします。`);
    }
}

/**
 * 野菜とカテゴリの組み合わせを取得
 */
function createVegeCategoryDict() {
    return new Promise(function(resolve, reject) {
        const url = PRTC_API_URL_BASE + 'vegecategory';
        $.get(url)
            .done(function(data) {
                vc_dict = data['item_dict'];
                resolve();
            })
            .fail(function(error) {
                console.log(error);
                reject(error);
            });
    });
}

/**
 * 野菜選択時の処理
 */
function onChangeVegetableSelector(e) {
    onChangePlaceType();
}